import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from '@/app';
import { captureAttribution } from '@/lib/acquisition';
import { initI18n } from '@/lib/i18n';
import { SessionProvider } from '@/lib/session';
import { ThemeProvider } from '@/lib/theme';
import '@/styles/global.css';

initI18n();

// Boucle virale (doc 06 §7.3) : l'origine est saisie à l'ARRIVÉE, avant tout rendu.
// Le parcours réel repasse par l'email (`/app/auth?token=…`), une URL qui a perdu
// `?src=` et `?vertical=` — les lire plus tard serait les lire trop tard.
captureAttribution(globalThis.location.search);

// Réseau de bar : on ne retente pas indéfiniment une donnée froide, et le live ne
// passe pas par ce cache (doc 03 §2.1).
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
  },
});

const container = document.getElementById('root');
if (container === null) {
  throw new Error('#root introuvable');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <SessionProvider>
          <BrowserRouter basename={import.meta.env.BASE_URL}>
            <App />
          </BrowserRouter>
        </SessionProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
